module.exports = __webpack_public_path__ + "img/landscape-icon.a36238e2.jpg";